import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class FormHelperService {
  constructor() {
  }

  UrlStringValidator(control: AbstractControl):{[key: string]: boolean} | null {
    let value: string = control.value;
    if (!value) {
      return null;
    }
    value = value.toLowerCase();
    if (!value.startsWith('http://') && !value.startsWith('https://')) {
      return {'urlStringError': true}
    }
    return null;
  };

}
